import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { parseAndSetFlag } from "utils/Utils";
import ToastModal from "views/components/ToastModal";

const WebSocketChat = ({ setNotifications, featureFlag }) => { 
  const [messages, setMessages] = useState([]);
  const [msg, setMsg] = useState("");
  const [websokUrl, setWsUrl] = useState("");
  const socketRef = useRef(null);
  const { authToken } = useSelector((state) => state.login.authData);
  const flag= true

  const loadWsUrl = async () => {
    const result = await apiHandler({ url: endpoint.WEB_SOCKET });
    setWsUrl(result?.data?.websocketUrl);
  };
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    if(websokUrl === "" && flag){
    loadWsUrl();
    }
  }, [websokUrl, flag]);
       const getMessageNotification = async () => {
      const result = await apiHandler({
        url: endpoint.FIND_WEB_SCOKET_MESSAGE,
        authToken: authToken,
      });
      if(result?.data?.error_code){
        toastUpdate("Error",result?.data?.user_description,true);
      }else{
        setNotifications(result?.data?.slice(0, 3));
      }
    };
  useEffect(() => {
    if (websokUrl && authToken) { 
      console.log("WebSocket component mounted");
      // FIX: your URL has "wss://https://" — remove duplicate https
      const wsUrl = `${websokUrl}?token=${authToken}`;
      console.log(socketRef, "ahksdhjakhsk");

      socketRef.current = new WebSocket(wsUrl);

      socketRef.current.onopen =async  () => {
         try {
         await getMessageNotification();     // <<----- your API function
          } catch (err) {
            console.log("Error in getMessageNotification:", err);
          }
        console.log("WS Connected");
      };

      socketRef.current.onmessage = async (event) => {
       try {
         await getMessageNotification();     // <<----- your API function
          } catch (err) {
            console.log("Error in getMessageNotification:", err);
          }
      }
      socketRef.current.onerror = async (err) => {
        try {
         await getMessageNotification();     // <<----- your API function
          } catch (err) {
            console.log("Error in getMessageNotification:", err);
          }
      };

      socketRef.current.onclose = async () => {
                 try {
         await getMessageNotification();     // <<----- your API function
          } catch (err) {
            console.log("Error in getMessageNotification:", err);
          }
        console.log("WS Closed");
      };

      // Cleanup when component unmounts
      return () => {
        if (socketRef.current) socketRef.current.close();
      };
    }
  }, [websokUrl, authToken]);

  const sendMessage = () => {
    if (!msg.trim()) return;

    const payload = {
      eventType: "CLIENT_NEW",
      username: "client",
      message: msg,
    };

    socketRef.current.send(JSON.stringify(payload));
    setMsg("");
  };

  return (
      toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )
  );
};

export default WebSocketChat;
